// GA4 view_item_list + select_item for server-rendered product card lists.
//
// Product cards are rendered by Razor (ProductCarousel.cshtml,
// ProductsBlock.cshtml) and tagged with data-ga-* attributes; their container
// carries data-item-list="<list name>". This module reads those, pushes one
// view_item_list per list on load, and select_item when a card is clicked.
(function () {
  function toItem(card, index) {
    return {
      item_id: card.dataset.gaItemId || '',
      item_name: card.dataset.gaItemName || '',
      price: parseFloat(card.dataset.gaPrice) || 0,
      index: parseInt(card.dataset.gaIndex, 10) || index,
    };
  }

  function pushViewItemLists() {
    const lists = document.querySelectorAll('[data-item-list]');
    lists.forEach((list) => {
      if (list.dataset.gaListPushed === '1') return;
      const cards = [...list.querySelectorAll('.product-card[data-ga-item-id]')];
      if (!cards.length) return;

      list.dataset.gaListPushed = '1';
      const listName = list.dataset.itemList || 'Product List';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'custom_view_item_list',
        datalayer_event_name: 'view_item_list',
        ecommerce: {
          item_list_name: listName,
          items: cards.map((c, i) => ({ ...toItem(c, i), item_list_name: listName })),
        },
      });
    });
  }

  function onCardClick(e) {
    const card = e.target.closest('.product-card[data-ga-item-id]');
    if (!card) return;
    const list = card.closest('[data-item-list]');
    const listName = (list && list.dataset.itemList) || 'Product List';
    const index = [...(list ? list.querySelectorAll('.product-card[data-ga-item-id]') : [])].indexOf(card);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'custom_select_item',
      datalayer_event_name: 'select_item',
      ecommerce: {
        item_list_name: listName,
        items: [{ ...toItem(card, index), item_list_name: listName }],
      },
    });
  }

  function init() {
    pushViewItemLists();
    document.addEventListener('click', onCardClick);
    // Catch lists added after load (carousels, AJAX).
    new MutationObserver(pushViewItemLists).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
